import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=ef0549a0&scoped=true&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=ef0549a0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0549a0",
  null
  
)

export default component.exports